export const METRIC_DEFINITION_MAP_CONFIG = new Map([
	// Summary card
	[
		"planned_target",
		{
			header: "Planned Target",
			subHeader:
				"Planned production quantity as given in the plan upload",
			definition: "",
		},
	],
	[
		"rtt",
		{
			header: "Real Time Target",
			subHeader:
				"Ideal number of actual produced pieces based on the plan",
			definition:
				"[(Planned Target/Plan working minutes)*Worked minutes]",
		},
	],
	[
		"actual_production",
		{
			header: "Actual Production",
			subHeader: "Total number of actual pieces produced",
			definition: "[Total no. of actual pieces produced]",
		},
	],
	[
		"variance",
		{
			header: "Variance",
			subHeader: "Difference between actual production and RTT",
			definition: "[Actual Production - RTT]",
		},
	],
	[
		"trend",
		{
			header: "Predicted Trend",
			subHeader: "Predicted actuals based on the current production",
			definition:
				"[(Actual pieces produced/Worked minutes)*Planned working minutes]",
		},
	],
	[
		"wip",
		{
			header: "Work In Progress",
			subHeader:
				"No. of pieces that needed to be worked upon between two stations",
			definition: "[WIP between two chosen stations]",
		},
	],

	// multiple flex slider card 1
	[
		"AQL Pass%",
		{
			header: "Acceptance Quality Limit",
			subHeader:
				"Percentage of garment that has acceptable level of quality",
			definition: "[(No. of AQL pass pieces/AQL checked pieces)*100]",
		},
	],
	[
		"pass_audit_pcs",
		{
			header: "Acceptance Quality Limit",
			subHeader: "Amount of acceptably passed garment",
			definition: "[Total no. of AQL pass pieces]",
		},
	],
	[
		"endline_dhu",
		{
			header: "Defect per Hundred Units",
			subHeader: "Total number of defects detected per 100 garments",
			definition: "[Total defect count / checked pieces]",
		},
	],
	[
		"ftt_percentage",
		{
			header: "First Time Through",
			subHeader:
				"Total number of garment pieces that are approved at the End-line QC at the first attempt",
			definition:
				"[(First time passed units *100)/Total production units]",
		},
	],
	[
		"reject_percentage",
		{
			header: "Reject Rate",
			subHeader: "Percentage of rejected garment pieces",
			definition: "[(Reject count/checked pieces)*100]",
		},
	],
	[
		"duh_percentage",
		{
			header: "Defective Rate",
			subHeader: "Percentage of defective garment pieces",
			definition: "[(Defective count/checked pieces)*100]",
		},
	],

	// multiple flex slider card 2
	[
		"act_efficiency",
		{
			header: "Efficiency",
			subHeader: "Effectively spent time v/s total time spent",
			definition:
				"[[(SMV*Actual Quantity)/(Worked minutes*Member Count)]*100]",
		},
	],
	[
		"man_hours",
		{
			header: "Man Hours",
			subHeader:
				"Amount of work that one person can do within a particular period",
			definition: "[Member count*Worked minutes]",
		},
	],
	[
		"rt_sah",
		{
			header: "RT - SAH",
			subHeader: "Ideal SAH value",
			definition:
				"[[(SMV*Planned Quantity/60)/Total no. of minutes planned to work]*Worked minutes]",
		},
	],
	[
		"hit_rate",
		{
			header: "Hit Rate",
			subHeader: "Success rate of efficiency",
			definition: "[Acual Efficiency/Planned Efficiency]",
		},
	],

	// multiple flex slider card 3
	[
		"actual_total",
		{
			header: "Manpower",
			subHeader: "Total number of members",
			definition: "",
		},
	],
	[
		"actual_operators",
		{
			header: "Operator",
			subHeader: "Total number of operators",
			definition: "",
		},
	],
	[
		"actual_helpers",
		{
			header: "Helper",
			subHeader: "Total number of helpers",
			definition: "",
		},
	],

	// Factory view //
	// card 1
	[
		"noOfWorkingLines",
		{
			header: "Running Sewing Lines ",
			subHeader:
				"Total number of unique running lines with at least one FTT in the Sewing department",
			definition: "",
		},
	],
	[
		"operators",
		{
			header: "No. of Sewing Operators",
			subHeader: "Total no. of operators in the Sewing department",
			definition: "",
		},
	],
	[
		"poActual",
		{
			header: "Running Sewing POs",
			subHeader:
				"Total number of unique running PO's with at least one FTT in the Sewing department",
			definition: "",
		},
	],
	[
		"styleActual",
		{
			header: "Running Sewing Styles",
			subHeader:
				"Total number of unique running styles with at least one FTT in the Sewing department",
			definition: "",
		},
	],
	[
		"Total WIP_wip",
		{
			header: "Total WIP",
			subHeader: "Sum of the WIP accross departments",
			definition:
				"[Cutting WIP + Sewing WIP + Finishing WIP + Packing WIP]",
		},
	],
	[
		"cutPackRatio",
		{
			header: "Cut to Pack Ratio",
			subHeader:
				"Percentage of garments packed out of total no. of garments cut for the order",
			definition: ["[(Packed pieces/Cut pieces)*100]"],
		},
	],

	// card 2
	[
		"sewingActual",
		{
			header: "Sewing Actuals",
			subHeader: "Actual successful produced pieces",
			definition: "[Sewing Endline QC FTT +Rework count]",
		},
	],
	[
		"finishingActual",
		{
			header: "Finishing Actuals",
			subHeader: "Actual successful finished pieces",
			definition: "[Finishing Endline QC FTT +Rework count]",
		},
	],
	[
		"packingActual",
		{
			header: "Packing Actuals",
			subHeader: "Actual successful packed pieces",
			definition: "[Total no. of actual packed pieces]",
		},
	],
	[
		"cuttingActual",
		{
			header: "Cutting Actuals",
			subHeader: "Actual cut quantity based on bundle quantity",
			definition: "[Tag-generation cut quantity]",
		},
	],

	// card 3 (sewing)
	[
		"sewing_runningStyle",
		{
			header: "No. of Working Styles",
			subHeader:
				"Total number of styles with at least one FTT or packed piece event for the session date",
			definition: "",
		},
	],
	[
		"sewing_wip",
		{
			header: "Work In Progress",
			subHeader: "WIP accross sewing",
			definition: "",
		},
	],
	[
		"efficiency",
		{
			header: "Efficiency",
			subHeader: "Effectively spent time v/s total time spent",
			definition:
				"[[(SMV*Actual Quantity)/(Worked minutes*Member Count)]*100]",
		},
	],
	[
		"sah",
		{
			header: "Standard Allowed Hours",
			subHeader: "Number of hours of production time",
			definition: "[(SMV*Actual Quantity)/60]",
		},
	],
	[
		"sewing_manHour",
		{
			header: "Man Hours",
			subHeader:
				"Amount of work that all members of department can do within a particular period",
			definition: "[Member count*Worked minutes]",
		},
	],
	[
		"ftt",
		{
			header: "First Time Through",
			subHeader:
				"Total number of garment pieces that are approved at the End-line QC at the first attempt",
			definition:
				"[(First time passed units *100)/Total production units]",
		},
	],
	[
		"overallDhu",
		{
			header: "Overall DHU",
			subHeader: "Total number of defects detected per 100 garments",
			definition: "[Total defect count / checked pieces]",
		},
	],
	[
		"defectiveRate",
		{
			header: "Defective Rate",
			subHeader: "Percentage of defective garment pieces",
			definition: "[(Defective count/checked pieces)*100]",
		},
	],
	[
		"rejectRate",
		{
			header: "Reject Rate",
			subHeader: "Percentage of rejected garment pieces",
			definition: "[(Reject count/checked pieces)*100]",
		},
	],

	// card 3 (finishing)
	[
		"finishing_runningStyle",
		{
			header: "No. of Working Styles",
			subHeader:
				"Total number of styles with at least one FTT or packed piece event for the session date",
			definition: "",
		},
	],
	[
		"finishing_wip",
		{
			header: "Work In Progress",
			subHeader: "WIP accross finishing",
			definition: "",
		},
	],
	[
		"finishing_manHour",
		{
			header: "Man Hours",
			subHeader:
				"Amount of work that all members of department can do within a particular period of time",
			definition: "[Member count*Worked minutes]",
		},
	],

	// card 3 (cutting)
	[
		"cutting_runningStyle",
		{
			header: "No. of Working Styles",
			subHeader: "Count of cutbank in styles",
			definition: "",
		},
	],
	[
		"cutting_wip",
		{
			header: "WIP",
			subHeader: "WIP accross Cutting",
			definition: "",
		},
	],

	// card 3 (packing)
	[
		"packer_runningStyle",
		{
			header: "No. of Working Styles",
			subHeader:
				"Total number of styles with at least one packed piece event for the session date",
			definition: "",
		},
	],
	[
		"packer_wip",
		{
			header: "WIP",
			subHeader: "WIP accross Packing",
			definition: "",
		},
	],

	// "Lines (Sewing & Finishing -Prodiction)"   !--- card 0 ----!
	[
		"style",
		{
			header: "Running Style",
			subHeader:
				"Total number of unique running styles with at least one FTT",
			definition: "",
		},
	],
	[
		"smv",
		{
			header: "Standard Minute Value",
			subHeader:
				"Standard time allowed to an operator (worker) to complete a task",
			definition:
				"[Basic minute + Bundle allowances + Machine allowances + Personal fatigue allowances]",
		},
	],
	[
		"production_hour",
		{
			header: "Production Hour",
			subHeader: "Current session block of total planned session blocks",
			definition: "",
		},
	],

	// cutting meta card
	[
		"actual_pieces",
		{
			header: "Actal Cut Pieces",
			subHeader: "Total number of cut pieces",
			definition: "",
		},
	],
	[
		"previous_day_wip",
		{
			header: "Previous Day WIP",
			subHeader: "Previous day's work in progress quantity",
			definition:
				"[[Sum(Checked-in pieces)-Sum(Checked-out pieces)]-Sum(Cleared quantity)]",
		},
	],
	[
		"cut_bank_in",
		{
			header: "Cut Bank In",
			subHeader: "Checked-in quantity for the Cut Bank In",
			definition: "",
		},
	],
	[
		"cut_bank_out",
		{
			header: "Cut Bank Out",
			subHeader: "Checked-out quantity from the Cut Bank Out",
			definition: "",
		},
	],
	[
		"cut_bank_wip",
		{
			header: "Cut Bank WIP",
			subHeader: "Total number of pieces yet to be cut",
			definition: "",
		},
	],

	// order status meta card
	[
		"delivery_date",
		{
			header: "Delivery",
			subHeader: "Date of Delivery",
			definition: "",
		},
	],
	[
		"destination",
		{
			header: "Destination",
			subHeader: "Final desination of the Order",
			definition: "",
		},
	],
	[
		"order_qty",
		{
			header: "Order Quantity ",
			subHeader: "Total number of Order Quantity",
			definition: "",
		},
	],
	[
		"shippableQty",
		{
			header: "Shippable Quantity",
			subHeader: "Total number of Shippable Quantity",
			definition: "",
		},
	],
	[
		"cutQty",
		{
			header: "Cut Quantity",
			subHeader: "Total number of Cut Quantity ",
			definition: "",
		},
	],
	[
		"packedQty",
		{
			header: "Packed Quantity",
			subHeader: "Total number of Packed Quantity",
			definition: "",
		},
	],

	// Packing card

	[
		"pack_pcs",
		{
			header: "Total Packed Pieces",
			subHeader: "Total piece count",
			definition: "",
		},
	],
	[
		"pack",
		{
			header: "Total Packed Cartons",
			subHeader: "Total carton count",
			definition: "",
		},
	],

	// Sewing (Quality) |  Finishing (Quality) | Floor (Sewing & Finishing - Quality) | Lines (Sewing & Finishing - Quality)
	//   !----  card 1 ---!
	[
		"KEY_TOBE_ADDED",
		{
			header: "Right First Time",
			subHeader:
				"Total number of garment pieces that are approved at the End-line QC at the first attempt",
			definition:
				"[(First time passed units *100)/Total production units]",
		},
	],
	[
		"KEY_TOBE_ADDED",
		{
			header: "Reject Rate",
			subHeader:
				"Percentage of rejected garment pieces in the Endline QC",
			definition: "[(Reject count/checked pieces)*100]",
		},
	],
	[
		"KEY_TOBE_ADDED",
		{
			header: "Percentage of defective garment pieces",
			subHeader: "Percentage of defective garment pieces Endline QC",
			definition: "[(Defective count/checked pieces)*100]",
		},
	],

	// AQL card
	[
		"KEY_TOBE_ADDED",
		{
			header: "Running Style",
			subHeader: "Current running style in the Line",
			definition: "",
		},
	],
	[
		"KEY_TOBE_ADDED",
		{
			header: "Type",
			subHeader: "Category of the apparel",
			definition: "",
		},
	],
	[
		"KEY_TOBE_ADDED",
		{
			header: "Iron Man",
			subHeader: "Total number of Iron Man",
			definition: "",
		},
	],
	[
		"KEY_TOBE_ADDED",
		{
			header: "QC",
			subHeader: "Total number of QC Operators",
			definition: "",
		},
	],
]);
